import { VFlex } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c(VFlex,{staticClass:"text-center"},[_c('Lottie',{attrs:{"options":_vm.defaultOptions,"height":300,"width":300},on:{"animCreated":_vm.handleAnimation}}),_c('h2',{staticClass:"white--text"},[_vm._v("Loading...")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }